<template>
  <div>
    <v-sheet height="64">
      <v-row align="center" justify="center" no-gutters>
        <v-btn icon @click="prev" class="ma-0">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title class="mx-4">{{ tituloMes }}</v-toolbar-title>
        <v-btn icon @click="next" class="ma-0">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-row>
    </v-sheet>

    <v-sheet>
      <v-calendar
        ref="calendar"
        v-model="focus"
        color="primary"
        :events="eventos"
        :event-color="getEventColor"
        type="month"
        show-adjacent-months="false"
        :show-event-overlap="mostrarTodosEventos"
        :event-more="true"
        @click:event="confirmarRemocao"
        @change="emitirRange"
      >
        <template #more="{ events }">
          <div class="more-link" @click="mostrarTodosEventos = true">
            Mais {{ events.length }}
          </div>
        </template>
      </v-calendar>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'CalendarioEventos',
  props: {
    eventos: {
      type: Array,
      default: () => [],
    },
    anoCalendario: Number,
    mesInicio: Number,
    mesFinal: Number,
    start: String,
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      focus: '',
      ultimaDataValida: '',
      mostrarTodosEventos: false, // <- controla expansão
    }
  },
  watch: {
    start: {
      immediate: true,
      handler(novaData) {
        if (novaData) {
          this.focus = novaData
          this.ultimaDataValida = novaData
        }
      }
    },
    focus(novaData) {
      const data = new Date(novaData)
      const ano = data.getFullYear()
      const mes = data.getMonth() + 1

      const foraDoAno = ano !== this.anoCalendario
      const foraDoIntervalo = mes < this.mesInicio || mes > this.mesFinal

      if (foraDoAno || foraDoIntervalo) {
        this.focus = this.ultimaDataValida
      } else {
        this.ultimaDataValida = novaData
      }
    }
  },

  computed: {
    tituloMes() {
      if (this.$refs.calendar?.title) {
        const [mes] = this.$refs.calendar.title.split(' ')
        return mes.charAt(0).toUpperCase() + mes.slice(1)
      }

      if (this.focus) {
        const data = new Date(this.focus)
        const mes = data.toLocaleDateString('pt-BR', { month: 'long' })
        return mes.charAt(0).toUpperCase() + mes.slice(1)
      }

      return ''
    }
  },

  methods: {
    setToday() {
      const hoje = new Date()
      const ano = hoje.getFullYear()
      const mes = hoje.getMonth() + 1

      if (
        ano === this.anoCalendario &&
        mes >= this.mesInicio &&
        mes <= this.mesFinal
      ) {
        this.focus = hoje.toISOString().substr(0, 10)
      }
    },

    next() {
      const atual = new Date(this.focus)
      const anoAtual = atual.getFullYear()
      const mesAtual = atual.getMonth() + 1

      const anoPermitido = this.anoCalendario

      if (anoAtual === anoPermitido && mesAtual + 1 === 12) return

      const proximo = new Date(anoAtual, mesAtual, 1)
      const anoDestino = proximo.getFullYear()
      const mesDestino = proximo.getMonth() + 1

      const dentroDoLimite =
        anoDestino < anoPermitido ||
        (anoDestino === anoPermitido && mesDestino <= 12)

      if (dentroDoLimite) {
        this.focus = proximo.toISOString().substr(0, 10)
        this.$refs.calendar.next()
      }
    },

    prev() {
      const atual = new Date(this.focus)
      const anoAtual = atual.getFullYear()
      const mesAtual = atual.getMonth() + 1

      const anoPermitido = this.anoCalendario

      if (anoAtual === anoPermitido && mesAtual === 1) return

      const anterior = new Date(anoAtual, mesAtual - 2, 1)
      const anoDestino = anterior.getFullYear()
      const mesDestino = anterior.getMonth() + 1

      const dentroDoLimite =
        anoDestino > anoPermitido ||
        (anoDestino === anoPermitido && mesDestino >= 1)

      if (dentroDoLimite) {
        this.focus = anterior.toISOString().substr(0, 10)
        this.$refs.calendar.prev()
      }
    },

    getEventColor(evento) {
      return evento.color || 'primary'
    },

    confirmarRemocao({ event }) {
      if (this.isView) return
      this.$swal({
        text: 'Deseja excluir o evento?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result) {
          this.$emit('removerEvento', event)
        }
      })
    },

    emitirRange({ start, end }) {
      this.$emit('atualizarRange', { start, end })
    },
  }
}
</script>

<style scoped>
.v-sheet {
  border-radius: 12px;
}
.more-link {
  color: #1976d2;
  font-size: 12px;
  cursor: pointer;
  padding: 4px;
}
</style>
